import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuTrigger, } from '../../../../components/shareable/dropdownMenu';
import { MoreVertical } from 'lucide-react';

const ConveyorTable = ({ conveyors, currentPage, onUpdateConveyor, onDeleteConveyor, itemsPerPage }) => {
  return (
    <div className="overflow-x-auto rounded-lg border border-gray-200 shadow-sm">
      <table className="min-w-full divide-y divide-gray-200 bg-white">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
              #
            </th>
            <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
              Part No.
            </th>
            <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
              Conveyor Name / Description
            </th>
            <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
              Conveyor Style
            </th>
            <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
              Image Name
            </th>
            <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
              Length
            </th>
            <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
              Our Cost
            </th>
            <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
              Total Cost
            </th>
            <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {conveyors.length > 0 ? (
            conveyors.map((conveyor, index) => (
              <tr key={conveyor._id} className="hover:bg-gray-50 transition-colors">
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-center">
                  {(currentPage - 1) * itemsPerPage + index + 1}
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-center">
                  {conveyor.part_number || <span className="italic text-gray-400">N/A</span>}
                </td>
                <td className="px-4 py-3 text-sm text-gray-900 max-w-xs">
                  <div className="line-clamp-2 break-words min-h-[2.5rem] flex items-center justify-center text-center">
                    {conveyor.conveyor_name || <span className="italic text-gray-400">No Name</span>}
                  </div>
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-center">
                  {conveyor.conveyor_style || <span className="italic text-gray-400">No Style</span>}
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-center">
                  {conveyor?.image_name || <span className="italic text-gray-400">N/A</span>}
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-center">
                  {conveyor.length ? `${conveyor.length}"` : <span className="italic text-gray-400">N/A</span>}
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-center">
                  {conveyor.babs_cost !== null && conveyor.babs_cost !== undefined ? 
                    `$${conveyor.babs_cost.toLocaleString()}` : 
                    <span className="italic text-gray-400">N/A</span>}
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-center">
                  {conveyor.total !== null && conveyor.total !== undefined ? 
                    `$${conveyor.total.toLocaleString()}` : 
                    <span className="italic text-gray-400">N/A</span>}
                </td>
                
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-center">
                  <DropdownMenu>
                    <DropdownMenuTrigger className="focus:outline-none">
                      <MoreVertical className="h-5 w-5 text-gray-500 hover:text-blue-600 transition-colors mx-auto" />
                    </DropdownMenuTrigger>
                    <DropdownMenuContent className="w-44 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
                      <DropdownMenuLabel className="px-3 py-2 text-xs font-medium text-gray-500 text-center">
                        Actions
                      </DropdownMenuLabel>
                      <DropdownMenuItem onClick={() => onUpdateConveyor(conveyor)} className="cursor-pointer px-3 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors" >
                        Update Conveyor
                      </DropdownMenuItem>
                      <DropdownMenuItem onClick={() => onDeleteConveyor(conveyor)} className="cursor-pointer px-3 py-2 text-sm text-red-600 hover:bg-red-50 hover:text-red-700 transition-colors" >
                        Delete
                      </DropdownMenuItem>
                    </DropdownMenuContent>
                  </DropdownMenu>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={9} className="px-6 py-8 text-center text-sm text-gray-500">
                <div className="flex flex-col items-center justify-center">
                  <svg className="w-12 h-12 text-gray-400 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  No conveyors available
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ConveyorTable;